import React from 'react'
import { graphql } from "gatsby"
import { PrismicRichText } from '@prismicio/react'
import styled from "@emotion/styled"
import loadable from '@loadable/component'
import { parse } from 'rss-to-json'
import reactStringReplace from 'react-string-replace'
import SimpleBar from 'simplebar-react'
import 'simplebar-react/dist/simplebar.min.css'
import { Play } from "phosphor-react"

import Content from '../components/content'
import Article from '../components/article'
import News from "../components/news"
import CenterMiddle from "../components/centermiddle"
import { Seo } from "../components/seo"
import Shopbar from "../components/shop-bar"

const Today = loadable(() => import('../components/today'))

const Divwrap = styled.div`
margin-top: 3vh;
h2 {
    margin-bottom: 2.5vh;
    font-family: 'OpticianSans';
    font-size: 1.33rem;
    letter-spacing: 1px;    
}
@media (max-width: 599px) {
    transform: none;
    grid-row: 1;
}
`
const Subhead = styled.h2`
color: #000;
background: #fff;
margin-bottom: 2.5vh;
font-family: 'OpticianSans';
font-size: 1.33rem;
letter-spacing: 1px;
`
const Archivewrap = styled.div`
max-height: 30vh;
overflow-x: scroll;
ul {
    background: #fff;
}
li {
    list-style: none;
    margin-bottom: 1.5vh;
    @media (max-width: 599px) {
        width: 90%;
    }
    a {
        svg {
            display: inline;
            padding-right: 6px;
            padding-top: 3px;
        }
        border-bottom: solid 1px rgba(0,0,0,0.33);
        font-family: "FaktPro-Normal";
        font-size: .9125rem;
        line-height: 1em;
        transition: all 0.3s ease;
        &:hover {
            color: red;
            border-bottom-color: red;
        }
        @media (max-width: 599px) {
            font-size: 1rem;
        }  
    }
}
`

const Tagline = styled.h3`
    font-family: "courier";
    font-size: 1.125rem;
    line-height: 1.5em;
    margin-bottom: 5vh;
    color: #000;
    letter-spacing: .25px;
    padding: 0 15vw;
    text-align: center;
    span {
        background-color: #fff;
        border-bottom: solid 1px rgba(0,0,0,0.5);
    }
    @media (max-width: 599px) {
        font-size: .875rem;
        padding: 0 5vw;
    }  
`

const Grid = styled.div`
    padding: 0 2vw;
    display: grid;
    grid-template-columns: 2fr 3fr 2fr;
    grid-column-gap: 4vw;
    position: relative;
    z-index: 4;
    @media (max-width: 599px) {
        grid-template-columns: 1fr;
        top: 0;
        padding: 0 5vw;
    }
    > div {
        @media (max-width: 599px) {
            position: static;
            margin-bottom: 7.5vh;
            &:nth-of-type(1) {
                grid-row: 3;
            }
            &:nth-of-type(2) {
                grid-row: 1;
            }
            &:nth-of-type(3) {
                grid-row: 2;
            }
        }
    }
`

const Homepage = ({ data, serverData } )=> {
    if (!data) return null
    const home = data.prismicHomepage.data

    // const { items } = serverData

    return (
        <>
            <Content>
                <Tagline><span>Decentralized community radio featuring music, talk, performance, and experiments broadcast LIVE from around the United States</span></Tagline>
                <Grid>
                <News />
                <Today />
                <div>
                <CenterMiddle />
                <Divwrap>
            {/* <Subhead>Recent Shows</Subhead> */}
        {/* <SimpleBar> */}
        {/* <Archivewrap>
                <ul>
      {items.map((item, index) => {
        const {
            title,
            link
        } = item;
        return (
            <li key={index}><a href={link}><Play weight="duotone" />{reactStringReplace(title, /\[[^\]]*\]\s/i, (match, i) => (<span key={i}>{match}</span>))}</a></li>
        )
        }
      )}
      </ul>
      </Archivewrap> */}
      {/* </SimpleBar> */}
      </Divwrap>
                </div>
                </Grid>
            </Content>
            <Shopbar />
            {home.sections.map(({ section }) => 
                <Content key={section.document.id} iD={section.document.uid}>
                    <Article>
                        <PrismicRichText field={section.document.data.title.richText} />
                        <PrismicRichText field={section.document.data.body.richText} />
                    </Article>
                </Content>
            )}
        </>
    )
}

export default Homepage

export const Head = () => (
    <Seo title="LIVE!"/>
)  

export const pageQuery = graphql`
query {
    prismicHomepage {
      id
      data {
        sections {
          section {
            document {
              ... on PrismicPage {
                id
                uid
                data {
                  title {
                    richText
                  }
                  body {
                    richText
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`

// export async function getServerData() {
//     try {
//       const rss = await parse('https://rssbox.us-west-2.elasticbeanstalk.com/mixcloud/gutsyradio/gutsyradio')
//     //   console.log(JSON.stringify(rss, null, 3))
  
//       return {
//         status: 200,
//         props: {
//             title: rss.title,
//             items: rss.items
//         }
//       }
//     } catch (error) {
//         console.error(error);
//         return {
//           status: 500,
//           props: {
//             error: error
//           }
//         };
//       }
//   }